import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';
import { useUIStore } from '../../store/ui.store';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import styles from './AppLayout.module.css';

interface AppLayoutProps {
  title?: string;
  breadcrumbs?: { label: string; path?: string }[];
}

export function AppLayout({ title, breadcrumbs }: AppLayoutProps) {
  const { accessToken } = useAuthStore();
  const { sidebarCollapsed } = useUIStore();

  if (!accessToken) return <Navigate to="/login" replace />;

  return (
    <div className={styles.root}>
      <Sidebar />
      <Header title={title} breadcrumbs={breadcrumbs} />
      <main
        className={styles.main}
        style={{ marginLeft: sidebarCollapsed ? 56 : 220 }}
      >
        <Outlet />
      </main>
    </div>
  );
}
